const initialState = {
	organizationName: '',
	country: '',
	pushNotificationTimer: 0,
	smsPushNotificationTimer: 0,
	defaultEndCallNotification: '',
	keepNotificationsPeriodInDays: 0,
	contactCenterNameMaxLength: 0,
	defaultNotificationMaxLength: 0,
	unverifiedCallArrivalNotificationMaxLength: 0,
	customNotificationMaxLength: 0,
	keepCallsPeriodInDays: 0,
	refreshAnalyticsDataIntervalInSeconds: 0,
	keepRatingsPeriodInDays: 0,
	refreshThresholdsIntervalInMinutes: 0,
	rowsPerPage: {
		marketingEventLogNotifications: 10,
		pushNotifications: 10,
		contactCenters: 10,
		users: 10,
		customerRegistrations: 10,
		spoofPreventionList: 10,
		alerts: 10,
		appointmentList: 10,
	},
	licenseSettings: null,
	allowedCountryForPhoneNumbers: '',
	enableFraudProtection: 'true',
};

const settingsReducer = (state = initialState, action) => {
	switch (action.type) {

		case 'USER_LOGOUT':
			return initialState;

		case 'SET_NUMBER_ROWS_PER_PAGE':
			return {
				...state,
				rowsPerPage: {
					...state.rowsPerPage,
					[action.payload.value.table]: action.payload.value.rowsPerPage
				}
			};

		case 'SET_PORTAL_SETTINGS': {
			const {
				organizationName,
				country,
				pushNotificationTimer,
				smsPushNotificationTimer,
				defaultEndCallNotification,
				keepNotificationsPeriodInDays,
				contactCenterNameMaxLength,
				defaultNotificationMaxLength,
				unverifiedCallArrivalNotificationMaxLength,
				customNotificationMaxLength,
				keepCallsPeriodInDays,
				refreshAnalyticsDataIntervalInSeconds,
				keepRatingsPeriodInDays,
				refreshThresholdsIntervalInMinutes,
				allowedCountryForPhoneNumbers,
				enableFraudProtection,
			} = action.payload;

			return {
				...state,
				organizationName,
				country,
				pushNotificationTimer,
				smsPushNotificationTimer,
				defaultEndCallNotification,
				keepNotificationsPeriodInDays,
				contactCenterNameMaxLength,
				defaultNotificationMaxLength,
				unverifiedCallArrivalNotificationMaxLength,
				customNotificationMaxLength,
				keepCallsPeriodInDays,
				refreshAnalyticsDataIntervalInSeconds,
				keepRatingsPeriodInDays,
				refreshThresholdsIntervalInMinutes,
				allowedCountryForPhoneNumbers,
				enableFraudProtection,
			};
		}

		case 'SET_LICENSE_SETTINGS':
			return {
				...state,
				licenseSettings: action.payload,
			};

		default:
			return state;
	}
};

export const setPortalSettingsActionCreator = (payload) => ({
	type: 'SET_PORTAL_SETTINGS',
	payload,
});

export const setNumberRowsPerPageActionCreator = (value) => ({
	type: 'SET_NUMBER_ROWS_PER_PAGE',
	payload: {
		value
	}
});

export const setLicenseSettingsActionCreator = (payload) => ({
	type: 'SET_LICENSE_SETTINGS',
	payload,
});

export default settingsReducer;
